export function searchProps(feature, searchTerm) {
    const name = feature.properties.name
        ? feature.properties.name.toLowerCase()
        : '';
    const loca = feature.properties.location
        ? feature.properties.location.toLowerCase()
        : '';
    const desc = feature.properties.description
        ? feature.properties.description.toLowerCase()
        : '';
    const term = searchTerm.toLowerCase();

    return name.includes(term) || loca.includes(term) || desc.includes(term);
}
